export enum DiasSemana {
    SEGUNDA = 'segunda',
    TERCA = 'terca',
    QUARTA = 'quarta',
    QUINTA = 'quinta',
    SEXTA = 'sexta',
    SABADO = 'sabado',
    DOMINGO = 'domingo',
}
